<template>
  <svg width="24px" height="24px"
       viewBox="0 0 24 24" version="1.1"
       xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>atoms/icons/24x24/cv/bekwaamheid redgreen</title>
    <g id="atoms/icons/24x24/cv/bekwaamheid-redgreen" stroke="none"
       stroke-width="1" fill="none"
       fill-rule="evenodd">
      <path d="M14.5,5.5 C14.5,6.88071187 13.3807119,8 12,8 C10.6192881,8 9.5,6.88071187 9.5,5.5 C9.5,4.11928813 10.6192881,3 12,3 C13.3807119,3 14.5,4.11928813 14.5,5.5 Z M21,12.0002341 C21,12.8286612 20.3284271,13.5002341 19.5,13.5002341 L3.5,13.5002341 C2.67157288,13.5002341 2,12.8286612 2,12.0002341 C2,11.171807 2.67157288,10.5002341 3.5,10.5002341 L19.5,10.5002341 C20.3284271,10.5002341 21,11.171807 21,12.0002341 Z" id="Combined-Shape"
            fill="#28A246"></path>
      <path d="M14.5,18.5 C14.5,19.8807119 13.3807119,21 12,21 C10.6192881,21 9.5,19.8807119 9.5,18.5 C9.5,17.1192881 10.6192881,16 12,16 C13.3807119,16 14.5,17.1192881 14.5,18.5 Z M20.5,10.5 C21.3284271,10.5 22,11.1715729 22,12 C22,12.8284271 21.3284271,13.5 20.5,13.5 L9.63636364,13.5 L12.9083636,10.5 L20.5,10.5 Z" id="Combined-Shape"
            fill="#F9574E"></path>
    </g>
  </svg>
</template>
<script setup>
// dummy comment to surpress rollup build errors with dynamic imports
// if the file doesn't contain a script tag with content, the build fails.
</script>
